import React, {useState} from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import _ from "lodash";

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const LoanBalanceTable = ({ printMode = false }) => {
  const { list, loading, balanceTotal } = useSelector(
    (state) => state.loanBalance
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };


  const openingTotal = _.sumBy(list, (r) => Number(r.opening_balance) || 0);
  const receivedTotal = _.sumBy(list, (r) => Number(r.received_total) || 0);
  const paymentTotal = _.sumBy(list, (r) => Number(r.payment_total) || 0);

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "Account Name", dataIndex: "acc_name" },
    {
      title: "Opening Balance",
      dataIndex: "opening_balance",
      align: "right",
      render: (val) => fmt(val),
    },
    {
      title: "Received Amount",
      dataIndex: "received_total",
      align: "right",
      render: (val) => fmt(val),
    },
    {
      title: "Payment Amount",
      dataIndex: "payment_total",
      align: "right",
      render: (val) => fmt(val),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      align: "right",
      render: (val) => fmt(val),
    },
  ];

  if (printMode) {
  return (
    <table className="loan-balance-print-table">
      <tbody>
        <tr className="loan-balance-print-heading">
          <td>No.</td>
          <td>Account Name</td>
          <td style={{ textAlign: "right" }}>Opening Balance</td>
          <td style={{ textAlign: "right" }}>Received Amount</td>
          <td style={{ textAlign: "right" }}>Payment Amount</td>
          <td style={{ textAlign: "right" }}>Balance</td>
        </tr>

        {list.map((row, index) => (
          <tr key={row.acc_id || index} className="loan-balance-print-row">
            <td>{index + 1}</td>

            <td>{row.acc_name}</td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.opening_balance)}
            </td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.received_total)}
            </td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.payment_total)}
            </td>

            <td style={{ textAlign: "right" }}>
              {fmt(row.balance)}
            </td>
          </tr>
        ))}

        <tr className="loan-balance-print-total">
          <td colSpan={2} style={{ textAlign: "right" }}>
            Grand Total :
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(openingTotal)}
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(receivedTotal)}
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(paymentTotal)}
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(balanceTotal)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}


  return (
    <Table
      rowKey={(record, idx) => record.acc_id || idx}
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      size={printMode ? "small" : "middle"}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={2} align="right">
            <strong>Grand Total :</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={2} align="right">
            <strong>{fmt(openingTotal)}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={3} align="right">
            <strong>{fmt(receivedTotal)}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={4} align="right">
            <strong>{fmt(paymentTotal)}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={5} align="right">
            <strong>{fmt(balanceTotal)}</strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default LoanBalanceTable;
